/* loaded by smart-asset */
export default require("./loader~oKpOSUuf.gif")